import { ListaPerfil } from "@/contexts/autorizacao/perfil/pages/ListaPerfil";
import { Route } from "react-router";

// As rotas são renderizadas dentro do layout autenticado em app/routes.tsx.
// Retorna um Fragment (e não um componente) porque <Routes> só aceita
// <Route> ou Fragment como filhos diretos.
export function perfilRoutes() {
  return (
    <>
      <Route path="/perfis" element={<ListaPerfil />} />
    </>
  );
}
